/* YAZ Origin — behaviour + motion (GSAP/ScrollTrigger optional, everything degrades). ≤ 20 KB. */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var reduced = html.classList.contains('ya-reduced') || (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var rtl = html.getAttribute('dir') === 'rtl';
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var params = new URLSearchParams(w.location.search);
  w.__yaBooted = true;

  /* ---------- reveals ---------- */
  function reveals() {
    var els = $$('.ya-reveal, .ya-stagger');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in w)) { els.forEach(function (e) { e.classList.add('ya-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('ya-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
    // section head rules draw in
    if (w.gsap && w.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      $$('.ya-head__rule').forEach(function (r) {
        gsap.fromTo(r, { scaleX: 0 }, { scaleX: 1, duration: 0.9, ease: 'power3.out', scrollTrigger: { trigger: r, start: 'top 88%', once: true } });
      });
    }
  }

  /* ---------- header ---------- */
  function header() {
    var h = $('[data-ya-header]'); if (!h) return;
    var onScroll = function () { h.classList.toggle('is-stuck', w.scrollY > 40); };
    w.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    $$('[data-ya-sub]', h).forEach(function (li) {
      var btn = $('button', li);
      var open = function (v) { li.classList.toggle('is-open', v); btn.setAttribute('aria-expanded', v ? 'true' : 'false'); };
      btn.addEventListener('click', function (e) { e.stopPropagation(); open(true); });
      li.addEventListener('mouseenter', function () { open(true); });
      li.addEventListener('mouseleave', function () { open(false); });
      d.addEventListener('click', function (e) { if (!li.contains(e.target)) open(false); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    });
    var dr = $('[data-ya-drawer]'), ob = $('[data-ya-drawer-open]'), cb = $('[data-ya-drawer-close]');
    if (dr && ob) {
      var set = function (v) { dr.classList.toggle('is-open', v); dr.setAttribute('aria-hidden', v ? 'false' : 'true'); ob.setAttribute('aria-expanded', v ? 'true' : 'false'); d.body.classList.toggle('ya-drawer-open', v); if (v && cb) cb.focus(); };
      ob.addEventListener('click', function () { set(true); });
      if (cb) cb.addEventListener('click', function () { set(false); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
      $$('a', dr).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    }
  }

  /* ---------- hero: search bar + parallax ---------- */
  function hero() {
    var f = $('[data-ya-search]'); if (!f) return;
    var tg = $('[data-ya-search-toggle]', f);
    if (tg) tg.addEventListener('click', function () { var o = f.classList.toggle('is-open'); tg.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    var date = $('[data-ya-date]', f);
    if (date) {
      var toDate = function () { if (date.type !== 'date') { date.type = 'date'; date.min = new Date().toISOString().slice(0, 10); try { date.showPicker && date.showPicker(); } catch (e) {} } };
      date.addEventListener('focus', toDate); date.addEventListener('click', toDate);
      date.addEventListener('blur', function () { if (!date.value) date.type = 'text'; });
    }
    // car → handover (pick-up | delivered + map) → date → product page (or fleet when no car chosen)
    var carSel = $('[data-ya-car]', f), ho = $('[data-ya-handover]', f);
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var h = ho && ho.__ya ? ho.__ya : null;
      if (h && !h.validate()) { f.classList.add('is-open'); return; }
      var q = new URLSearchParams();
      var st = h ? h.state : { mode: 'pickup' };
      q.set('mode', st.mode || 'pickup');
      if (st.mode === 'delivery') { if (st.address) q.set('address', st.address); if (st.lat) { q.set('lat', st.lat); q.set('lng', st.lng); } }
      if (date && date.value) q.set('from', date.value);
      var opt = carSel && carSel.options[carSel.selectedIndex], url = (opt && opt.getAttribute('data-url')) || f.getAttribute('data-fleet-url') || f.action;
      if (carSel && carSel.value) q.set('car', carSel.value);
      w.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + q.toString();
    });
    if (carSel && params.get('car')) carSel.value = params.get('car');
    var car = $('.ya-hero__car'), title = $('[data-ya-hero-title]');
    if (!reduced && w.gsap) {
      if (title) gsap.from(title, { y: 40, opacity: 0, duration: 1.1, ease: 'power3.out', delay: 0.1 });
      gsap.from(f, { y: 30, opacity: 0, duration: 1, ease: 'power3.out', delay: 0.35 });
      if (car && w.ScrollTrigger) gsap.to(car, { yPercent: 8, ease: 'none', scrollTrigger: { trigger: '.ya-hero', start: 'top top', end: 'bottom top', scrub: true } });
    }
  }

  /* ---------- generic fade slider (daily offers) ---------- */
  function offers() {
    var root = $('[data-ya-offers]'); if (!root) return;
    var slides = $$('[data-ya-slide]', root), dots = $$('[data-ya-slider-dots] .ya-dots__dot', root);
    if (slides.length < 2) return;
    var i = 0, timer;
    var go = function (n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (dd, k) { dd.classList.toggle('is-active', k === i); dd.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    };
    dots.forEach(function (dd, k) { dd.addEventListener('click', function () { go(k); restart(); }); });
    var restart = function () { clearInterval(timer); if (!reduced) timer = setInterval(function () { go(i + 1); }, 7000); };
    restart();
    var sx = 0; root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) { go(i + ((dx < 0) !== rtl ? 1 : -1)); restart(); } });
  }

  /* ---------- explore 360 ---------- */
  function explore() {
    var root = $('[data-ya-explore]'); if (!root) return;
    var tabs = $$('[data-ya-tab]', root), stages = $$('[data-ya-stage]', root), deg = $('[data-ya-deg]', root);
    if (!stages.length) return;
    var cur = 0, frame = 0, auto = null;
    var stage = function () { return stages[cur]; };
    var imgs = function () { return $$('.ya-explore__img', stage()); };
    var show = function (n) {
      var list = imgs(); if (!list.length) return;
      frame = ((n % list.length) + list.length) % list.length;
      list.forEach(function (im, k) { im.classList.toggle('is-on', k === frame); });
      if (deg) deg.textContent = Math.round(frame / list.length * 360);
    };
    var load = function (s) { $$('.ya-explore__img[data-src]', s).forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }); };
    var pick = function (k) {
      cur = k; stages.forEach(function (s, j) { s.hidden = j !== k; s.classList.toggle('is-active', j === k); });
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
      load(stage()); show(0);
    };
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { pick(k); }); });
    stages.forEach(function (s) {
      var fr = $('[data-ya-frame]', s), down = false, sx = 0, sf = 0;
      var step = function () { return Math.max(18, fr.clientWidth / Math.max(6, imgs().length * 2)); };
      fr.addEventListener('pointerdown', function (e) { down = true; sx = e.clientX; sf = frame; fr.classList.add('is-dragging'); fr.setPointerCapture && fr.setPointerCapture(e.pointerId); stop(); });
      fr.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; show(sf + Math.round(dx / step()) * (rtl ? -1 : 1)); });
      var up = function () { down = false; fr.classList.remove('is-dragging'); };
      fr.addEventListener('pointerup', up); fr.addEventListener('pointercancel', up); fr.addEventListener('lostpointercapture', up);
      fr.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); show(frame + (e.deltaX > 0 ? 1 : -1)); stop(); } }, { passive: false });
      var stop = function () { clearInterval(auto); auto = null; };
      fr.addEventListener('mouseenter', function () { if (reduced || auto) return; auto = setInterval(function () { if (!down) show(frame + 1); }, 900); });
      fr.addEventListener('mouseleave', stop);
      fr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') show(frame + 1); if (e.key === 'ArrowLeft') show(frame - 1); });
      fr.setAttribute('tabindex', '0');
    });
    pick(0);
  }

  /* ---------- why us tabs ---------- */
  function why() {
    var root = $('[data-ya-why]'); if (!root) return;
    var tabs = $$('[data-ya-why-tab]', root), contents = $$('[data-ya-why-content]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = +t.getAttribute('data-ya-why-tab');
        contents.forEach(function (c) { var on = +c.getAttribute('data-ya-why-content') === k; c.hidden = !on; c.classList.toggle('is-active', on); });
        tabs.forEach(function (b) { var on = +b.getAttribute('data-ya-why-tab') === k; b.hidden = on; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.classList.toggle('is-active', on); });
        if (!reduced && w.gsap) gsap.fromTo(contents[k], { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.45, ease: 'power2.out' });
      });
    });
  }

  /* ---------- accordions: one open at a time per group ---------- */
  function accordions() {
    $$('.ya-acc').forEach(function (g) {
      var items = $$('[data-ya-acc]', g);
      items.forEach(function (it) { it.addEventListener('toggle', function () { if (it.open) items.forEach(function (o) { if (o !== it) o.open = false; }); }); });
    });
  }

  /* ---------- WhatsApp links: append dates from URL / product panel ---------- */
  function waDates(from, to, per, handover) {
    var tail = '';
    if (per) tail += ' (' + per + ')';
    if (from) tail += (rtl ? ' من ' : ' from ') + from;
    if (to) tail += (rtl ? ' إلى ' : ' to ') + to;
    if (handover) tail += (tail ? '. ' : '. ') + handover;
    if (!tail) return;
    $$('[data-ya-wa]').forEach(function (a) {
      var base = a.getAttribute('data-base') || a.href; a.setAttribute('data-base', base);
      a.href = base + encodeURIComponent(tail + '.');
    });
  }

  /* ---------- fleet filters ---------- */
  function fleet() {
    var root = $('[data-ya-fleet]'); if (!root) return;
    var items = $$('[data-ya-item]', root), cards = items.map(function (li) { return $('[data-ya-car]', li); });
    var inputs = $$('[data-ya-f]', root), nores = $('[data-ya-nores]', root), count = $('[data-ya-count]', root);
    var pmin = +root.getAttribute('data-pmin'), pmax = +root.getAttribute('data-pmax');
    var rmin = $('[data-ya-f="pmin"]', root), rmax = $('[data-ya-f="pmax"]', root), fill = $('[data-ya-range-fill]', root);
    var lmin = $('[data-ya-range-min]', root), lmax = $('[data-ya-range-max]', root);
    var fmt = function (n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
    var vals = function (name) { return inputs.filter(function (i) { return i.getAttribute('data-ya-f') === name && i.checked; }).map(function (i) { return i.value; }); };
    var apply = function () {
      var types = vals('type'), makes = vals('make'), trans = vals('trans'), seats = vals('seats');
      var lo = rmin ? +rmin.value : pmin, hi = rmax ? +rmax.value : pmax;
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      var shown = 0, active = types.length + makes.length + trans.length + seats.length + ((lo > pmin || hi < pmax) ? 1 : 0);
      cards.forEach(function (c, k) {
        if (!c) return;
        var ok = true, price = +c.getAttribute('data-price') || 0, mk = c.getAttribute('data-make') || '';
        if (types.length && types.indexOf(c.getAttribute('data-type')) < 0) ok = false;
        if (makes.length && !makes.some(function (m) { return mk.indexOf(m) === 0 || m.indexOf(mk) === 0; })) ok = false;
        if (trans.length && trans.indexOf(c.getAttribute('data-trans')) < 0) ok = false;
        if (seats.length && seats.indexOf(c.getAttribute('data-seats')) < 0) ok = false;
        if (price && (price < lo || price > hi)) ok = false;
        items[k].hidden = !ok; if (ok) shown++;
      });
      if (nores) nores.hidden = shown > 0 || !cards.length;
      if (count) count.textContent = active ? '(' + active + ')' : '';
      if (fill && rmin && rmax) {
        var a = (lo - pmin) / Math.max(1, pmax - pmin) * 100, b = (hi - pmin) / Math.max(1, pmax - pmin) * 100;
        fill.style[rtl ? 'right' : 'left'] = a + '%'; fill.style[rtl ? 'left' : 'right'] = (100 - b) + '%';
        if (lmin) lmin.textContent = fmt(lo); if (lmax) lmax.textContent = fmt(hi);
      }
      var q = new URLSearchParams(w.location.search);
      ['type', 'make', 'trans', 'seats'].forEach(function (n) { q.delete(n); });
      types.forEach(function (v) { q.append('type', v); }); makes.forEach(function (v) { q.append('make', v); }); trans.forEach(function (v) { q.append('trans', v); }); seats.forEach(function (v) { q.append('seats', v); });
      if (hi < pmax) q.set('max', hi); else q.delete('max');
      if (lo > pmin) q.set('min', lo); else q.delete('min');
      var qs = q.toString(); history.replaceState(null, '', w.location.pathname + (qs ? '?' + qs : ''));
    };
    inputs.forEach(function (i) { i.addEventListener('input', apply); i.addEventListener('change', apply); });
    $$('[data-ya-clear]', root).forEach(function (b) { b.addEventListener('click', function () { inputs.forEach(function (i) { if (i.type === 'checkbox') i.checked = false; }); if (rmin) rmin.value = pmin; if (rmax) rmax.value = pmax; apply(); }); });
    var tg = $('[data-ya-rail-toggle]', root), rail = $('[data-ya-rail]', root);
    if (tg && rail) tg.addEventListener('click', function () { var o = rail.classList.toggle('is-open'); tg.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    // seed from URL (hero search / deep links)
    var seed = function (name, list) { list.forEach(function (v) { inputs.forEach(function (i) { if (i.getAttribute('data-ya-f') === name && (i.value === v || (name === 'make' && (i.value.indexOf(v) === 0 || v.indexOf(i.value) === 0)))) i.checked = true; }); }); };
    seed('type', params.getAll('type')); seed('make', params.getAll('make')); seed('trans', params.getAll('trans')); seed('seats', params.getAll('seats'));
    if (rmax && params.get('max')) rmax.value = Math.min(pmax, Math.max(pmin, +params.get('max')));
    if (rmin && params.get('min')) rmin.value = Math.max(pmin, Math.min(pmax, +params.get('min')));
    apply();
  }

  /* ---------- product page ---------- */
  function pdp() {
    var root = $('[data-ya-pdp]'); if (!root) return;
    var slides = $$('[data-ya-gslide]', root), segs = $$('[data-ya-gseg]', root), i = 0;
    var go = function (n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); var v = $('video', s); if (v) { if (k === i) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } } });
      segs.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    };
    segs.forEach(function (s, k) { s.addEventListener('click', function () { go(k); }); });
    var pv = $('[data-ya-gprev]', root), nx = $('[data-ya-gnext]', root);
    if (pv) pv.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    var g = $('[data-ya-gallery]', root), sx = 0;
    if (g) { g.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true }); g.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(i + ((dx < 0) !== rtl ? 1 : -1)); }); }
    d.addEventListener('keydown', function (e) { if (e.target.closest('input,textarea,select')) return; if (e.key === 'ArrowRight') go(i + (rtl ? -1 : 1)); if (e.key === 'ArrowLeft') go(i - (rtl ? -1 : 1)); });
    // period switch
    var pbs = $$('[data-ya-period]', root), price = $('[data-ya-price]', root), label = $('[data-ya-price-label]', root), vid = $('[data-ya-variant-id]', root);
    var period = 'day';
    pbs.forEach(function (b) {
      b.addEventListener('click', function () {
        pbs.forEach(function (o) { o.classList.toggle('is-active', o === b); o.setAttribute('aria-selected', o === b ? 'true' : 'false'); });
        if (price) price.textContent = b.getAttribute('data-price');
        if (label) label.textContent = b.getAttribute('data-label');
        if (vid && b.getAttribute('data-vid')) vid.value = b.getAttribute('data-vid');
        period = b.getAttribute('data-ya-period'); waText();
      });
    });
    // dates → WhatsApp text + line item properties
    var from = $('[data-ya-from]', root), to = $('[data-ya-to]', root), pf = $('[data-ya-prop-from]', root), pt = $('[data-ya-prop-to]', root);
    var today = new Date().toISOString().slice(0, 10);
    if (from) { from.min = today; if (params.get('from')) from.value = params.get('from'); }
    if (to) { to.min = today; if (params.get('to')) to.value = params.get('to'); }
    // handover (pick-up | delivered to me + address) → WhatsApp text + line-item properties
    var ho = $('[data-ya-handover]', root), ph = $('[data-ya-prop-handover]', root), pa = $('[data-ya-prop-address]', root), pmap = $('[data-ya-prop-map]', root);
    var hoText = function () {
      var h = ho && ho.__ya ? ho.__ya : null; if (!h) return '';
      var st = h.state, isDel = st.mode === 'delivery';
      if (ph) ph.value = isDel ? h.t('prop-delivery') : h.t('prop-pickup');
      if (pa) pa.value = isDel ? (st.address || '') : '';
      if (pmap) pmap.value = isDel && st.lat ? 'https://www.google.com/maps?q=' + st.lat + ',' + st.lng : '';
      if (isDel) return st.address ? h.t('wa-delivery').replace('%s', st.address) : h.t('prop-delivery');
      return h.t('wa-pickup');
    };
    var waText = function () {
      var f = from && from.value, t = to && to.value;
      if (pf) pf.value = f || ''; if (pt) pt.value = t || '';
      if (from && to && f) { to.min = f; if (t && t < f) { to.value = ''; t = ''; } }
      var act = pbs.filter(function (b) { return b.classList.contains('is-active'); })[0];
      waDates(f, t, act ? act.textContent.trim() : '', hoText());
      var msg = $('[data-ya-msg]'); if (msg && (f || t) && !msg.dataset.touched) { var base = msg.getAttribute('data-base') || msg.value; msg.setAttribute('data-base', base); msg.value = base.replace(/\.?\s*$/, '') + (f ? (rtl ? ' من ' : ' from ') + f : '') + (t ? (rtl ? ' إلى ' : ' to ') + t : '') + '.'; }
    };
    if (from) from.addEventListener('change', waText);
    if (to) to.addEventListener('change', waText);
    if (ho) { ho.addEventListener('ya:handover', waText); if (!ho.__ya && w.__yaHandoverBoot) w.__yaHandoverBoot(); }
    // reserve-online form: block submit while "delivered to me" has no address
    var pform = $('form[data-type="add-to-cart-form"]', root);
    if (pform && ho) pform.addEventListener('submit', function (e) { var h = ho.__ya; if (h && !h.validate()) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    var msg = $('[data-ya-msg]'); if (msg) msg.addEventListener('input', function () { msg.dataset.touched = '1'; });
    waText();
    var pre = pbs.filter(function (b) { return b.classList.contains('is-active'); })[0]; if (pre && vid && pre.getAttribute('data-vid')) vid.value = pre.getAttribute('data-vid');
  }

  /* ---------- RTL: keep Latin/number runs in Arabic titles in reading order ("911 GT3 RS", "7-speed PDK") ---------- */
  function bidi() {
    if (!rtl) return;
    var re = /[A-Za-z0-9][A-Za-z0-9.\-\/+]*(?: [A-Za-z0-9][A-Za-z0-9.\-\/+]*)*/g;
    var sel = '.ya-card__title, .ya-pdp__title, .ya-phero__title, .ya-crumbs, .ya-explore__tab, .ya-offer__copy .ya-h3, .ya-spec dd, .ya-specs__grid dd, .ya-brand__body h3';
    $$(sel).forEach(function (root) {
      if (root.hasAttribute('data-ya-bidi')) return;
      root.setAttribute('data-ya-bidi', '');
      var walker = d.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], n;
      while ((n = walker.nextNode())) { if (n.nodeValue.trim() && /[A-Za-z0-9]/.test(n.nodeValue) && /[\u0600-\u06FF]/.test(root.textContent)) nodes.push(n); }
      nodes.forEach(function (t) {
        var s = t.nodeValue, last = 0, m, frag = d.createDocumentFragment(), hit = false;
        re.lastIndex = 0;
        while ((m = re.exec(s))) {
          if (!/[A-Za-z]/.test(m[0]) && !/\d\s*[\/.\-]/.test(m[0]) && m[0].indexOf(' ') < 0) continue; // plain numbers are fine
          hit = true;
          if (m.index > last) frag.appendChild(d.createTextNode(s.slice(last, m.index)));
          var b = d.createElement('bdi'); b.setAttribute('dir', 'ltr'); b.textContent = m[0]; frag.appendChild(b);
          last = m.index + m[0].length;
        }
        if (!hit) return;
        if (last < s.length) frag.appendChild(d.createTextNode(s.slice(last)));
        t.parentNode.replaceChild(frag, t);
      });
    });
  }

  function boot() {
    bidi(); reveals(); header(); hero(); offers(); explore(); why(); accordions(); fleet(); pdp();
    if (!$('[data-ya-pdp]')) waDates(params.get('from'), params.get('to'));
    if (w.ScrollTrigger) setTimeout(function () { ScrollTrigger.refresh(); }, 600);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
